<template>
    <div class="d-flex h-100 flex-column pb-5">
        <b-nav class="user-panel-step-tabs">
            <b-nav-item
                v-for="(step, index) in steps"
                :key="index"
                :to="{name: step.routerName}"
                :class="{'complete': step.complete}"
                :disabled="true">{{step.name}}
            </b-nav-item>
        </b-nav>
        <btn-back v-if="$route.name === 'Step1' || $route.name === 'Step2'"/>
        <b-row class="mt-4" v-if="$route.name !== 'Step4'">
            <b-col md="9">
                <div class="text-center text-info my-2" v-show="$store.state.loading">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
                <address-settings :label="'Ship from'"
                                  v-show="!$store.state.loading"
                                  @getDefaultAddress="event => setDefaultAddress(event.value)"
                                  @changedAddress="event => changedAddress(event.value)"/>
            </b-col>
            <b-col>
                <h6 class="font-weight-bold mb-3">Ship To:</h6>
                <p class="mb-0">
                    Veiveriu 142,
                    Kaunas 46353 Lithuania
                </p>
            </b-col>
        </b-row>
        <hr class="d-block w-100 mt-5 mb-5">
        <router-view :key="renderKey"></router-view>
    </div>
</template>

<script>
    import AddressSettings from '~cp/UserPanel/Elements/AddressSettings'

    export default {
        name: 'CreateShipment',
        components: {
            AddressSettings
        },
        data() {
            return {
                selected: null,
                defaultAddress: null,
                renderKey: 0,
                steps: [
                    {
                        routerName: 'Step1',
                        name: 'Label products',
                        complete: true
                    },
                    {
                        routerName: 'Step2',
                        name: 'Prepare shipment',
                        complete: false
                    },
                    {
                        routerName: 'Step3',
                        name: 'Delivery options',
                        complete: false
                    },
                    {
                        routerName: 'Step4',
                        name: 'Summary',
                        complete: false
                    },
                ]
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.$api('GET', vm.$endpoints.income(vm.$route.params.planId))
                    .then(response => {
                        if (response.planStatus === 'shipment_created') {
                            vm.$router.push({name: 'InventoryReplenishment'})
                        }
                    })
            })
        },
        beforeRouteUpdate(to, from, next) {
            this.nextStepAction(to.name)
            next()
        },
        created() {
            this.currentRouteValidation()
        },
        computed: {
            getSteps() {
                return this.steps
            }
        },
        methods: {
            nextStepAction(from) {
                this.steps.forEach(step => {
                    if (step.routerName === from) {
                        step.complete = true
                    }
                })
            },
            currentRouteValidation() {
                let validation = this.steps.find(step => step.routerName === this.$route.name).complete
                let completeSteps = this.steps.filter(step => step.complete)
                if (!validation) {
                    this.$router.push({name: completeSteps[completeSteps.length - 1].routerName})
                }
            },
            setDefaultAddress(data) {
                this.defaultAddress = data
            },
            changedAddress(data) {
                if (this.defaultAddress !== data) {
                    // this.selected = data
                    // this.defaultAddress = null
                    this.saveAddress(data)
                }
            },
            saveAddress(data) {
                if (data) {
                    // this.$api('PUT', this.$endpoints.incomeAddresse(this.$route.params.planId), this.selected)
                    data.default = true
                    this.$api('PUT', this.$endpoints.userAddress(data.id), data)
                        .then(() => {
                            this.$store.dispatch('globalAlertAction', {
                                type: 'info',
                                title: `Shipping address changed`
                            })
                            // reset old default address inside select
                            if (this.selected) this.selected.default = false
                            if (this.defaultAddress) this.defaultAddress.default = false
                            this.selected = data
                            this.defaultAddress = data
                            if (this.$route.name === 'Step3') this.renderKey++
                        })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/CreateShipment/CreateShipment.vue